/**
 * Shared project-ref sort comparator.
 *
 * Groups projects by their alphabetic prefix (everything before the first
 * digit) then orders by the leading number inside the group. This produces:
 *
 *    LC107    →  prefix="LC",  num=107
 *    LC1081   →  prefix="LC",  num=1081
 *    LUX208   →  prefix="LUX", num=208
 *    LUX216   →  prefix="LUX", num=216
 *
 * Prefix ordering: alphabetical (LC before LUX), so all LC projects render
 * together, then all LUX projects together, with anything else last.
 *
 * Tiebreaker: locale string compare on the full project_ref.
 */
const parseRef = (ref = '') => {
  // Match leading letters + the first run of digits.
  // "LUX208-DEV-10 The Avenue" → ["LUX208…","LUX","208"]
  // "LC1081 Cherry Tree Lodge" → ["LC1081…","LC","1081"]
  const m = (ref || '').match(/^([A-Za-z]+)\s*(\d+)/);
  if (m) {
    return { prefix: m[1].toUpperCase(), num: parseInt(m[2], 10), unknown: false };
  }
  return { prefix: (ref || '').toUpperCase(), num: Number.MAX_SAFE_INTEGER, unknown: true };
};

export const compareProjectRefs = (a, b) => {
  const ra = (a && a.project_ref) || '';
  const rb = (b && b.project_ref) || '';
  const pa = parseRef(ra);
  const pb = parseRef(rb);
  // Unknown-format refs always go to the bottom.
  if (pa.unknown !== pb.unknown) return pa.unknown ? 1 : -1;
  if (pa.prefix !== pb.prefix) return pa.prefix.localeCompare(pb.prefix);
  if (pa.num !== pb.num) return pa.num - pb.num;
  return ra.localeCompare(rb);
};

export const sortProjectsByRef = (projects = []) =>
  [...projects].sort(compareProjectRefs);
